import {
	DataList,
	Drawer,
	Paragraph,
	Show,
	TableFilter,
	tokens,
} from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import { DrawerEmployeesWrapper } from './components/DrawerEmployees/DrawerEmployeesWrapper';
import { EmptyPopulation } from './components/EmptyPopulation/EmptyPopulation';
import { PopulationFilters } from './components/PopulationFilters/PopulationFilters';
import { TrafficLights } from './components/TrafficLights/TrafficLights';
import { usePopulation } from './Population.hooks';
import { Container, Header, LayoutPage } from './Population.styles';
import { PatientResponse } from './Population.types';

export const Population = (): JSX.Element => {
	const {
		data,
		height,
		filters,
		loading,
		totalPages,
		currentPage,
		tableHeaders,
		isFilterOpen,
		selectedGroup,
		isTableLoading,
		handleSearch,
		handleFilters,
		onToggleFilter,
		formatDataRows,
		handleChangePage,
		selectedEmployees,
		setSelectedEmployees,
		isDrawerEmployeeVisible,
		handleCloseDrawerEmployees,
	} = usePopulation();

	const isProduction = import.meta.env.VITE_ENV === 'production';

	return (
		<>
			<Container data-testid="population-list">
				<TableFilter
					open={isFilterOpen}
					height={height - 300}
					filters={filters}
					onSearch={handleSearch}
					onClose={onToggleFilter}
					onOpen={onToggleFilter}
				>
					<PopulationFilters
						height={height - 300}
						onSearch={handleSearch}
						onChangeFilters={handleFilters}
						filters={filters}
					/>
				</TableFilter>
				<LayoutPage>
					<Header>
						<Paragraph
							fontSize="16px"
							fontWeight="600"
							margin="0 0 0 10px"
							color={tokens.color_primary}
						>
							Colaboradores dentro del grupo de riesgo: {selectedGroup?.name}
						</Paragraph>
						<Button
							width="220px"
							onClick={() => handleCloseDrawerEmployees(false)}
							disabled={
								isProduction || loading || selectedEmployees.length === 0
							}
						>
							Editar estatus de actividad
						</Button>
					</Header>
					<Show
						when={Boolean(data.length) || !loading}
						fallback={<EmptyPopulation loading={loading} />}
					>
						<TrafficLights
							data={data.employeesCountByRiskLevel}
							onChangeFilters={handleFilters}
							onSearch={handleSearch}
						/>
						<Show when={!loading || !isTableLoading} fallback={null}>
							<DataList
								key={Number(isTableLoading)}
								externalOrder
								selected={selectedEmployees}
								onSelect={(data) =>
									setSelectedEmployees(data as PatientResponse[])
								}
								height={`${height - 300}px`}
								loading={loading}
								headers={tableHeaders}
								currentPage={currentPage}
								pageSize={filters.pageSize}
								pagesNumber={totalPages}
								onChangePageSize={(size) => handleFilters({ pageSize: size })}
								onChangePage={handleChangePage}
								rows={formatDataRows(data?.employees || [])}
								onOrder={(orderField, orderSet) =>
									handleFilters({ orderField, orderSet })
								}
							/>
						</Show>
					</Show>
				</LayoutPage>
			</Container>
			<Show when={isDrawerEmployeeVisible} fallback={null}>
				<Drawer
					onClose={() => handleCloseDrawerEmployees(false)}
					open={isDrawerEmployeeVisible}
					position="right"
				>
					<DrawerEmployeesWrapper
						employees={selectedEmployees}
						onClose={(refetch) => handleCloseDrawerEmployees(refetch)}
					/>
				</Drawer>
			</Show>
		</>
	);
};
